import { takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { combineReducers } from 'redux';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';

const SEARCH_PROGRAMS = 'petersons/SEARCH_PROGRAMS';
const SEARCH_SCHOOLS = 'petersons/SEARCH_SCHOOLS';
const SUBMIT_RESPONSE = 'petersons/SUBMIT_RESPONSE';
const CHANGE_CHECK = 'petersons/CHANGE_CHECK';

export const searchProgramsAction = (payload, { resolve, reject } = {}) => ({
    type: SEARCH_PROGRAMS,
    payload,
    resolve,
    reject,
});

export const searchSchoolsAction = (payload, { resolve, reject } = {}) => ({
    type: SEARCH_SCHOOLS,
    payload,
    resolve,
    reject,
});

export const submitResponseAction = (payload, { resolve, reject } = {}) => ({
    type: SUBMIT_RESPONSE,
    payload,
    resolve,
    reject,
});

export const changeCheckAction = payload => ({
    type: CHANGE_CHECK,
    payload,
});

export function* rootSaga() {
    yield [
        takeLatest(SEARCH_PROGRAMS, searchPrograms),
        takeLatest(SEARCH_SCHOOLS, searchSchools),
        takeLatest(SUBMIT_RESPONSE, submitResponse),
        // takeEvery(LOCATION_CHANGE, checkAssessment),
        // takeEvery(actionKey.success(SIGNUP), markCheckOnSignup),
    ];
}

const checkReducer = (state = false, action) => {
    switch (action.type) {
        case CHANGE_CHECK:
            return action.payload;
        case actionKey.success(SUBMIT_RESPONSE):
            return true;
        default:
            return state;
    }
};

export default combineReducers({
    check: checkReducer,
});

function* searchPrograms({ type, payload, reject, resolve }) {
    if (!payload) {
        resolve();
        return;
    }
    const result = yield call(request, {
        url: `/api/petersons/programs-search?q=${payload}`,
        type,
    });
    if (result && result.error) {
        reject(result.error);
    } else if (result) {
        resolve({
            options: result.payload.programs.map(({ name }) => ({ label: name, id: name })),
        });
    } else {
        reject(new Error('Something went wrong'));
    }
}

function* searchSchools({ type, payload, reject, resolve }) {
    if (!payload) {
        resolve();
        return;
    }
    const result = yield call(request, {
        url: `/api/petersons/schools-search?q=${payload}`,
        type,
    });
    if (result && result.error) {
        reject(result.error);
    } else if (result) {
        resolve({
            options: result.payload.schools.map(({ name }) => ({ label: name, id: name })),
        });
    } else {
        reject(new Error('Something went wrong'));
    }
}

function* submitResponse({ type, payload, reject, resolve }) {
    const result = yield call(request, {
        url: '/api/petersons/response',
        type,
        options: {
            method: 'POST',
            body: payload,
        },
    });

    if (result && result.error) {
        reject(result.error);
    } else {
        resolve();
        yield put(push('/'));
    }
}

// function* checkAssessment({ payload }) {
//     const {
//         theme,
//         petersons,
//         auth,
//     } = yield select();
//     if (theme.companyDomain === 'petersons') {
//         return;
//     }
//     if (auth.level < 5) {
//         return;
//     }
//     const onWelcome = payload.pathname === '/welcome';
//     if (petersons.check) {
//         if (onWelcome) {
//             yield put(push('/'));
//         }
//         return;
//     }
//     const result = yield call(request, {
//         url: '/api/petersons/check',
//         type: CHECK_REQUEST,
//     });

//     if (!result || result.error) {
//         // not sure how to handle this
//         // so for now let's ignore this
//         return;
//     }
//     yield put(changeCheckAction(result.payload.found));
//     yield redirect();
// }

// function* markCheckOnSignup() {
//     const {
//         theme,
//         auth,
//     } = yield select();
//     if (theme.companyDomain === 'petersons') {
//         return;
//     }
//     if (auth.level < 5) {
//         return;
//     }
//     yield put(changeCheckAction(false));
//     yield redirect();
// }


// function* redirect() {
//     const {
//         petersons,
//         router: { location },
//     } = yield select();
//     const onWelcome = location.pathname === '/welcome';
//     if (petersons.check && onWelcome) {
//         yield put(push('/'));
//     } else if (!petersons.check && !onWelcome) {
//         yield put(push('/welcome'));
//     }
// }



// WEBPACK FOOTER //
// ./src/client/redux/petersons.js